// extracted by mini-css-extract-plugin
export default {"cta":"IE-z","disabled":"JE-z"};